export class Models {
}
export enum FormMode {
    None = 1,
    Find,
    New,
    Edit,
    Del
  }

  export interface ISelectable {
    selected: boolean;
  }

  export class Provider implements ISelectable {
    constructor() {
    }
    public id: number;
    public name: string;
    public engine: string;

    public selected: boolean;
  }

  export class Carrier implements ISelectable {
    constructor() {
    }
    public id: number;
    public name: string;
    public engine: string;
    public accountNumber: string;
    public apiUsername: string;
    public apiPassword: string;
    public apiAccessKey: string;
    public trackingFormat: number;
    public isMultiCarrier: boolean;

    //public InvoiceFiles: CarrierInvoiceFile[];
    public childAccounts: CarrierChildAccount[];
    //public InvoiceFile: CarrierInvoiceFile;

    public selected: boolean;
  }

export class ServiceListItem implements ISelectable {
    constructor() {
    }
    public PlainText: string;
    public Symbol: string;
    public ServiceCode: string;
    public isRateshop: string;
    public DisplayInList: string;

    public selected: boolean;
  }

  export class CarrierRate implements ISelectable {
    constructor() {
    }
    public id: number;
    public carrierId: number;
    public rateFileId: number;
    public serviceCode: string;
    public billedWeight: string;
    public zone: string;
    public rate: string;
    public editDate: Date;
    public editedBy: string;

    public selected: boolean;
    public rowValue: string;
  }

  export class CarrierRateSheet {
    public cell: CarrierRate;
    public cells: CarrierRate[][];
    // public Cols: string[];
    public cols: string[];
    public rows: string[];
    public sheetName: string;
  }

  export enum FileParseStatus {
    New,
    Completed,
    Error
  }

  export class CarrierRateFile implements ISelectable {
    constructor() {
    }

    public id: number;
    public name: string;
    public label: string;
    public fileOriginalName: string;
    public fileVersion: string;
    public fileName: string;
    public filePath: string;
    public uploadedOn: Date;
    public carrierCode: string;
    public status: FileParseStatus;
    public statusLog: string;


    ClientCarrierRateFiles: ClientCarrierRateFile[];

    public carrierRate: CarrierRate;
    public carrierRateSheet: CarrierRateSheet;
    public ColList = [];

    //public serviceCode: string;
    public serviceCodes: string[];

    public selected: boolean;
  }

  export class CarrierInvoiceFile implements ISelectable {
    constructor() {

    }

    public id: number;
    public label: string;
    public fileOriginalName: string;
    public fileVersion: string;
    public fileName: string;
    public filePath: string;
    public uploadedOn: Date;
    public carrierId: number;
    public status: FileParseStatus;
    public statusLog: string;
    public Carrier: Carrier;
    public engine: string;

    public colList = [];
    public selected: boolean;
    // public carrierInvoicePackageLineItem: CarrierInvoicePackageLineItem
  }

  export class Client implements ISelectable {
    constructor() {
    }
    public id: number;
    public name: string;
    public billingID: string;
    public billingContactID: string;
    public billingDay: string;
    public billingFrequency: string;
    public lastBilled: string;
    public aPIKey: string;
    public clientMasterId: number;
    //public CarrierId: number;

    //public Carrier: Carrier;

    public carrierRateFiles: ClientCarrierRateFile[];
    public carriers: ClientCarrier[];
    public ratingProfiles: ClientRatingProfile[];

    public selected: boolean;
  }

  export class ClientMaster implements ISelectable {
    constructor() {
    }
    public id: number;
    public name: string;
    public billingID: string;
    public billingContactID: string;
    public billingDay: string;
    public billingFrequency: string;
    public lastBilled: string;
    public apiKey: string;
    public netTerms: number;
    public active: string;

    public selected: boolean;
  }

  export class ClientCarrierRateFile implements ISelectable {
    public carrierRateFileId: number;
    public carrierRateFile: CarrierRateFile;
    public clientId: number;
    public client: Client;
    public carrierCode: string;

    public selected: boolean;
  }

export class ClientCarrier implements ISelectable {
  public carrierId: number;
  public carrier: Carrier;
  public childAccountId: number;
  public childAccount: CarrierChildAccount;
  public childCarrier: string;
  public clientId: number;
  public client: Client;
  public carrierCode: string;

  public immediatePayments: boolean;
  public noMarkups: boolean;
  public bypassRateValidation: boolean;
  public transactionFee: number;
  public transactionFeePercentage: number;

  public selected: boolean;
}

export class CarrierChildAccount implements ISelectable {
  public id: number;
  public name: string;
  public carrier: Carrier;
  public carrierId: number;
  public accountNumber: string;
  public active: boolean;

  public selected: boolean;
}

export class ClientRatingProfile implements ISelectable {
  public ratingProfileId: number;
  public ratingProfile: RatingProfile;
  public clientId: number;
  public client: Client;
  public isActive: boolean;

  public selected: boolean;
}

export class RatingProfile implements ISelectable {
  public id: number;
  public profileName: string;
  public description: string;
  public createdAt: Date;
  public modifiedAt: Date;
  public serviceDiscounts: ServiceDiscount[];
  public accessorialDiscounts: AccessorialDiscount[];

  public selected: boolean;
}

export class ServiceDiscount {
  public id: number;
  public ratingProfileId: number;
  public ratingProfile: RatingProfile;
  public serviceType: string;
  public packaging: string;
  public minWeight: number;
  public maxWeight: number;
  public zone: string;
  public discountPercentage: number;
  public minimumCharge: number;
  public selected: boolean;

}

export class AccessorialDiscount {
  public id: number;
  public ratingProfileId: number;
  public ratingProfile: RatingProfile;
  public accessorialCode: string;
  public serviceType: string;
  public minWeight: number;
  public maxWeight: number;
  public zone: string;
  public discountPercentage: number;
  public flatRateOverride: number;
  public selected: boolean;

}

export class DIMDivisorOverride {
  public id: number;
  public ratingProfileId: number;
  public ratingProfile: RatingProfile;
  public serviceType: string;
  public dimDivisor: number;
  public selected: boolean;

}

  export class Customerinvoices implements ISelectable {

    constructor() {
    }
    public id: number;
    public total: string;
    public status: string;
    public invoiceDate: Date;
    public clientId: number;
    //public clientMasterId: number;
    public invoiceStartDate : Date;
    public invoiceEndDate: Date;
    // public invoiceMaxDate: Date;
    // public invoiceMinDate: Date;

    public selected: boolean;
  }

  // export class CarrierInvoicePackageLineItem implements ISelectable {
  //   constructor() {

  //   }

  //   public id: number;
  //   public code: string;
  //   public detailCode: string;
  //   public colList = [];
  //   public selected: boolean;
  // }
